import {Component, OnInit} from '@angular/core';
import {WizardNotificationHistoryService} from './wizard-notification-history.service';

import { DashboardWidgetLookup, DashboardWidgetContent } from '@serengeti/serengeti-dashboard';

@DashboardWidgetLookup('WizardNotificationHistoryComponent')
@Component({
  selector: 'app-wizard-notification-history',
  templateUrl: './wizard-notification-history.component.html',
  styleUrls: ['./wizard-notification-history.component.scss']
})
export class WizardNotificationHistoryComponent implements OnInit, DashboardWidgetContent {

  public feed: any[];

  constructor(private _feedService: WizardNotificationHistoryService) {
  }

  property(): boolean {
    return false;
  }

  configure(setting: any): void {
  }

  ngOnInit() {
    this._loadFeed();
  }

  expandMessage(message: any) {
    message.expanded = !message.expanded;
  }

  private _loadFeed() {
    this.feed = this._feedService.getData();
  }
}
